// extracted by mini-css-extract-plugin
module.exports = {"modal":"RefundDialog_modal__1pVlq","content":"RefundDialog_content__17zhe"};